import React from 'react';

import { configs } from '@hero/configs';
import { GiftMessageInputs } from '@hero/molecules';

function MessageForm({
  messageParams = {},
  shortcutTagsActive,
  onUpdateMessageParams,
  onUpdateOccasion,
  customMessageLength,
  renderCustomizeMessageModal
}) {
  return (
    <GiftMessageInputs
      shortcutTagsActive={shortcutTagsActive}
      senderName={messageParams.senderName}
      message={messageParams?.message}
      customMessageLength={customMessageLength}
      renderCustomizeMessageModal={renderCustomizeMessageModal}
      setSenderName={value => onUpdateMessageParams({ senderName: value })}
      setMessage={value => {
        if (configs?.experience?.customGiftMessageEditorEnabled) {
          const wordArray = value.split('\n');
          wordArray.length = 3;

          onUpdateMessageParams({
            message: value
          });
        } else {
          onUpdateMessageParams({
            message: value
          });
        }
      }}
      setOccasion={({ occasion }) => {
        onUpdateOccasion(occasion);
      }}
    />
  );
}

export { MessageForm };
